import React from 'react';

import { useHistory, useParams, useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';

import './ProjectNavigation.sass';
import { Tooltip } from 'antd';

function ProjectNavigation(props: any) {
	let history = useHistory();
	const params: any = useParams();
	const { t } = useTranslation();

	let index =
		(useRouteMatch({ path: '/projects/' + params?.id, exact: true }) ? 1 : 0) +
		(useRouteMatch('/projects/' + params?.id + '/' + t("models.indicator.slug")) ? 2 : 0) +
		(useRouteMatch('/projects/' + params?.id + '/' + t("models.constraint.slug")) ? 3 : 0) +
		(useRouteMatch('/projects/' + params?.id + '/' + t("models.stakefactor.slug")) ? 4 : 0) +
		(useRouteMatch({ path: '/projects/' + params?.id + '/' + t("models.option.slug"), exact: true }) ? 5 : 0) +
		(useRouteMatch('/projects/' + params?.id + '/options-evaluation') ? 6 : 0) +
		(useRouteMatch('/projects/' + params?.id + '/results') ? 7 : 0);

	return (
		<div className="ProjectNavigation">
			<Tooltip title={t("pages.project.title_short")} placement='right'>
				<a
					className={[index == 1 ? 'selected' : '', index > 1 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id);
					}}
				></a>
			</Tooltip>

			<div className="tail"></div>
			<Tooltip title={t("models.indicator.name_plural")}>
				<a
					className={[index == 2 ? 'selected' : '', index > 2 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id + '/' + t("models.indicator.slug"));
					}}
				></a>
			</Tooltip>

			<div className="tail"></div>

			<Tooltip title={t("models.constraint.name_plural")}>
				<a
					className={[index == 3 ? 'selected' : '', index > 3 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id + '/' + t("models.constraint.slug"));
					}}
				></a>
			</Tooltip>

			<div className="tail"></div>
			<Tooltip title={t("models.stakefactor.name_plural")}>
				<a
					className={[index == 4 ? 'selected' : '', index > 4 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id + '/' + t("models.stakefactor.slug"));
					}}
				></a>
			</Tooltip>

			<div className="tail"></div>
			<Tooltip title={t("models.option.name_plural")}>
				<a
					className={[index == 5 ? 'selected' : '', index > 5 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id + '/' + t("models.option.slug"));
					}}
				></a>
			</Tooltip>

			<div className="tail"></div>
			<Tooltip title={t("pages.optionEvaluation.title_short")}>
				<a
					className={[index == 6 ? 'selected' : '', index > 6 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id + '/options-evaluation');
					}}
				></a>
			</Tooltip>

			<div className="tail"></div>
			<Tooltip title={t("pages.results.title_short")} placement='left'>
				<a
					className={[index == 7 ? 'selected' : '', index > 7 ? 'filled' : ''].join(' ')}
					onClick={() => {
						history.push('/projects/' + params?.id + '/results');
					}}
				></a>
			</Tooltip>
		</div>
	);
}

export default ProjectNavigation;
